import { render } from "./ProductoCreate.vue?vue&type=template&id=19e2695c&scoped=true"
import script from "./ProductoCreate.vue?vue&type=script&lang=js"
export * from "./ProductoCreate.vue?vue&type=script&lang=js"

import "./ProductoCreate.vue?vue&type=style&index=0&id=19e2695c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e2695c"]])

export default __exports__